export default __webpack_public_path__ + "assets/img/avatar-10.85178a9.png";